import { render } from "./Join.vue?vue&type=template&id=4737a748"
import script from "./Join.vue?vue&type=script&lang=js"
export * from "./Join.vue?vue&type=script&lang=js"
script.render = render

export default script